import { useContext } from 'react';
import PropTypes from 'prop-types';
import { titles } from '../components/shared/CheckoutPaneTitle';
import { connect } from 'react-redux';
import { CheckoutServerVarsContext } from '../components/shared/CheckoutServerVarsContext';
import { navigateToPane } from '../actions/checkoutUIActions';
import { graphql, useFragment } from 'react-relay';
import { Link } from 'dibs-elements/exports/Link';
import { FormattedMessage } from 'dibs-react-intl';
import { useCheckoutSelector } from '../reducers/root';
import classNames from 'classnames';

import styles from './styles/CheckoutReviewStepDetailsContainer.scss';

const CheckoutReviewStepDetailsContainer = props => {
    const { pane, children, onNavigateToPane, dataTn, disableChangeLink } = props;
    const isProcessing = useCheckoutSelector(state => state.ui.isProcessing) || false;
    const { isMobile } = useContext(CheckoutServerVarsContext);

    const buyer = useFragment(
        graphql`
            fragment CheckoutReviewStepDetailsContainer_buyer on User {
                hasShippingAddresses
                hasCreditCards
                hasBankAccounts
            }
        `,
        props.buyer
    );

    const { hasShippingAddresses, hasCreditCards, hasBankAccounts } = buyer || {};

    function handleClick() {
        onNavigateToPane({
            pane,
            hasCreditCards,
            hasBankAccounts,
            hasShippingAddresses,
        });
    }

    const checkoutDetailsContainerClassName = classNames(styles.checkoutDetailsContainer, {
        [styles.isMobile]: isMobile,
    });
    const labelClassName = classNames(styles.label, { [styles.isMobile]: isMobile });

    return (
        <div className={checkoutDetailsContainerClassName}>
            <div className={labelClassName}>{titles[pane]}</div>
            <div className={styles.content}>{children}</div>
            {!disableChangeLink && (
                <div
                    className={classNames(styles.actions, {
                        [styles.disabledActions]: isProcessing,
                    })}
                >
                    <Link onClick={handleClick} dataTn={dataTn}>
                        <FormattedMessage
                            id="checkout.CheckoutReviewStepDetailsContainer.change"
                            defaultMessage="Change"
                        />
                    </Link>
                </div>
            )}
        </div>
    );
};

CheckoutReviewStepDetailsContainer.propTypes = {
    pane: PropTypes.string.isRequired,
    children: PropTypes.node,
    onNavigateToPane: PropTypes.func.isRequired,
    buyer: PropTypes.object.isRequired,
    dataTn: PropTypes.string,
    disableChangeLink: PropTypes.bool,
};

export default connect(null, dispatch => ({
    onNavigateToPane: payload => navigateToPane({ ...payload, dispatch }),
}))(CheckoutReviewStepDetailsContainer);
